<template>
  <el-container direction="vertical"
                element-loading-text="加载中">
    <Header />
    <Nav :menuList="menuList"
         ref="nav" />
    <div class="advertisement"
         v-if="$route.meta.title!='首页'&& topShow">
      <i class="el-icon-circle-close"
         style="z-index: 999;"
         @click="close('topShow')"></i>
      <a :href="adDetailsTop.blogroll"
         target="_blank"
         v-if="!adDetailsTop.isStop">
        <img v-if="!adDetailsTop.isStop"
             :src="adDetailsTop.pcImgUrl"
             alt="">
      </a>
    </div>
    <div style="margin-top: 10px">
      <tabs></tabs>
    </div>

    <el-container class="contetn-box">
      <!-- <el-aside>
        <Nav :menuList="menuList" />
      </el-aside> -->

      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>

    </el-container>
    <div class="advertisement"
         v-if="$route.meta.title!='首页'&& bottomShow"
         style="margin-bottom: 40px;">
      <i class="el-icon-circle-close"
         style="z-index: 999;"
         @click="close('bottomShow')"></i>
      <a :href="adDetailsBottom.blogroll"
         target="_blank"
         v-if="!adDetailsBottom.isStop">
        <img v-if="!adDetailsBottom.isStop"
             :src="adDetailsBottom.pcImgUrl"
             alt="">
      </a>
    </div>
    <el-footer height="30px"
               style="
        text-align: center;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 999;
      ">
      <div class="footer-left">
        <a href="http://www.rayqee.com/index.html"
           target="_blank">首页</a>
        <a href="http://www.rayqee.com/index.html#AboutUs"
           target="_blank">关于我们</a>
        <a href="http://www.rayqee.com/index.html#News"
           target="_blank">企业动态</a>
        <a href="http://www.rayqee.com/index.html#FunctionFeature"
           target="_blank">功能亮点</a>
        <a href="http://www.rayqee.com/index.html#CooperatedPartner"
           target="_blank">合作伙伴</a>
        <a href="http://www.rayqee.com/articleList.html?type=CooperativeNews"
           target="_blank">合作新闻</a>
        <a href="http://www.rayqee.com/articleList.html?type=MediaNews"
           target="_blank">传媒资讯</a>
        <a href="http://www.rayqee.com/index.html#JoinUs"
           target="_blank">加盟代理</a>
        <a href="http://www.rayqee.com/creating/index.html"
           target="_blank">加盟代理</a>
      </div>
      <div>
        CopyRight©{{ year }} <a href="http://www.rayqee.com/">珠海瑞启智慧科技有限公司</a> 粤ICP备2023115920号-1
      </div>
      <div class="footer-right">
        版本：V0.99.3.2 RC &nbsp; &nbsp; &nbsp; 技术支持：
        <span style="color: #048cf8; cursor: pointer"
              @click="nav">易奇科技</span>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import Header from "@/components/Header";
import Nav from "@/components/Nav";
import tabs from "@/components/tabs";
import { AdDetails } from "@/utils/mixin";

export default {
  components: {
    Header,
    Nav,
    tabs,
  },
  mixins: [AdDetails],

  data () {
    return {
      menuList: [],
      Company: "",
      loading: false,
      year: "",
      bottomShow: false,
      topShow: false,
      adDetailsTop: '',
      adDetailsBottom: '',

    };
  },
  created () {
    this.CompanyDetail();
    var date = new Date();
    this.year = date.getFullYear();
    this.getAdDetails('305561b8-8bac-4419-9944-5bae1ac41ab1', this, 'adDetailsTop');
    this.getAdDetails('e61a4b9b-6160-4593-ab3c-bccb4303e22d', this, 'adDetailsBottom');

  },
  watch: {

    adDetailsTop (val) {
      if (val.pcImgUrl && !val.isStop) {
        this.topShow = true
      }
    },
    adDetailsBottom (val) {
      if (val.pcImgUrl && !val.isStop) {
        this.bottomShow = true
      }
    },
  },
  methods: {
    // getMenuChildren(pid, list) {
    //   const children = [];
    //   list.forEach((v) => {
    //     if (v.parentId == pid) {
    //       children.push(v);
    //     }
    //   });
    //   return children;
    // },
    close (value) {
      this[value] = false;
    },
    nav () {
      window.open("https://www.eqlee.com/", "_blank");
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.Company = res.data;
          this.getRightsMenus();
        }
      });
    },
    getRightsMenus () {
      this.loading = true;
      this.$api.user.getRightsMenus().then((res) => {
        this.loading = false;

        // console.log(res);
        if (res.code == 0) {
          res.data.forEach((v) => {
            if (v.parentId == 0) {
              // const children = this.getMenuChildren(v.id, res.data);
              // v.children = children;
              if (v.id == 59 && this.Company.authenticationState == 0) {
                return;
              }
              this.menuList.push(v);
              //把报表菜单id缓存至本地
              if (v.actionUrl == "data") {
                window.sessionStorage.setItem("mRportId", v.id);
              }

              //localMenu.push({v});
            }
          });
          this.$store.commit("saveMenus", this.menuList);
        }
        this.$nextTick(() => {
          this.$store.commit("navHeight", this.$refs.nav.$el.offsetHeight);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-icon-circle-close {
  font-size: 25px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
.contetn-box {
  padding-bottom: 20px;
}
.advertisement {
  width: 100%;
  position: relative;
  height: 92px;
  // padding: 0 40px;
}
.footer-left,
.footer-right {
  width: 500px;
  text-align: left;
  padding-right: 20px;
  width: 550px;
  text-align: right;
}
.footer-left {
  text-align: left;
  a {
    margin-right: 10px;
    &:hover {
      color: #048cf8;
    }
  }
}
.el-container {
  height: 100%;
  overflow: hidden;
}
.el-aside {
  width: 200px !important;
  background-color: #304156;
}
.el-main {
  padding: 10px 40px 0px !important;

  // margin: 0 15px;
  overflow-x: hidden;
  // overflow-y: hidden;
}
.el-footer {
  // background-color: #fff;
  // border-top: 1px solid #ddd;
  background-color: rgb(243, 244, 248);
  // line-height: 34px;
  font-size: 12px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 100%;
}
a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的颜色 */
  margin: 0; /* 去除外边距 */
  padding: 0; /* 去除内边距 */
}
</style>

